import React from 'react'
import './Product_Specification.css'

const Product_Specification = ({ product }) => {

    const specification = [
        {
            title: "Material",
            subTitle: product?.material || " "
        },
        {
            title: "Product Specification",
            subTitle: product?.specification || " "
        },
        {
            title: "Approx. Weight",
            subTitle: product?.weight || " "

        },
        {
            title: "Product size",
            subTitle: product?.size || " "
        },
        {
            title: "Returnable ",
            subTitle: product?.is_returnable ? "YES" : "NO"
        },


    ]

    return (
        <div className='Product_Specification'>
            <h3>Product Specifications</h3>

            <div className='specification_div'>

                <div className='row'>
                    <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12'>
                        {specification?.map((item) => {

                            return (
                                <div className='row' >
                                    <div className='col-lg-5 col-md-5 col-sm-5 col-6'>
                                        <div className='title'>
                                            <p>{item?.title}</p><span>:</span>
                                        </div>
                                    </div>

                                    <div className='col-lg-6 col-md-6 col-sm-6 col-6'>
                                        <div className='subTitle'>
                                            <p>{item?.subTitle}</p>
                                        </div>
                                    </div>
                                </div>

                            )
                        })}
                    </div>
                </div>



            </div>
        </div >
    )
}

export default Product_Specification
